module.exports = __webpack_public_path__ + "static/media/olut.abd831c7.mp3";